/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { getIsPlaying } from 'redux/reducers/playerQueue';
import Player from 'components/Player';
import PlayerQueue from 'components/PlayerQueue';
import { withTranslation } from 'react-i18next';
import actions from 'redux/actions';
import protonesUtils from 'utils/protones';
import classNames from 'classnames';
import styles from './styles.module.scss';

import type { Track, PlaybackStatus, ReduxState, Translate } from 'types';

const mapStateToProps = (state: ReduxState) => {
  return {
    tracks: state.playerQueue.tracks,
    isPlayerQueueVisible: state.playerQueue.isPlayerQueueVisible,
    currentTrackIndex: state.playerQueue.currentTrackIndex,
    requestedPlaybackStatus: state.playerQueue.requestedPlaybackStatus,
    isPlaying: getIsPlaying(state),
  };
};

type Props = {
  className?: string,
  tracks: Track[],
  isPlayerQueueVisible: boolean,
  requestedPlaybackStatus: PlaybackStatus,
  currentTrackIndex: number,
  isPlaying: boolean,
  togglePlayerQueueVisibility: typeof actions.togglePlayerQueueVisibility,
  setCurrentTrack: typeof actions.setCurrentTrack,
  setPlaybackStatus: typeof actions.setPlaybackStatus,
  playTracks: typeof actions.playTracks,
  clearTracks: typeof actions.clearTracks,
  t: Translate,
};

class Footer extends React.Component<Props, void> {
  playerRef: any = null;

  _playTrack = (trackIndex: number) => {
    if (this.playerRef) {
      this.playerRef.playTrack(trackIndex);
    }
  };

  render() {
    const {
      className,
      tracks,
      requestedPlaybackStatus,
      isPlayerQueueVisible,
      currentTrackIndex,
      isPlaying,
      togglePlayerQueueVisibility,
      setCurrentTrack,
      setPlaybackStatus,
      clearTracks,
      playTracks,
      t,
    } = this.props;
    const playerTracks = tracks.map((track, index) => {
      const author =
        (track.performers &&
          track.performers.length !== 0 &&
          track.performers
            .map(protonesUtils.getPersonShortLabel)
            .filter(_ => _ && _.length !== 0)
            .find(_ => _)) ||
        t('UNKNOWN_ARTIST');
      return {
        id: track.id,
        artist: author,
        title: track.title,
        albumArtUrl: protonesUtils.getTrackCoverUrl(track),
        url: protonesUtils.getTrackAudioUrl(track),
      };
    });
    return (
      <div
        className={classNames(
          className,
          isPlayerQueueVisible ? styles.footerExpanded : styles.footerCollapsed
        )}
      >
        <Player
          tracks={playerTracks}
          requestedPlaybackStatus={requestedPlaybackStatus}
          initialTrackIndex={currentTrackIndex}
          isPlayerPlaylistVisible={isPlayerQueueVisible}
          onShowPlaylistClick={togglePlayerQueueVisibility}
          onCurrentTrackChange={setCurrentTrack}
          onPlaybackStatusChange={setPlaybackStatus}
          ref={ref => (this.playerRef = ref)}
        />
        <PlayerQueue
          tracks={tracks}
          currentTrackIndex={currentTrackIndex}
          isPlaying={isPlaying}
          onTrackClick={this._playTrack}
          onClearClick={clearTracks}
          playTracks={playTracks}
        />
      </div>
    );
  }
}

export default withTranslation()(connect(mapStateToProps, actions)(Footer));
